/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LastNameFirstLetter/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import ChoiceRadial from 'DesignSystem/ChoiceRadial/index'
import Question from 'DesignSystem/Question/index'
import React from 'react'
import Timeout from 'DesignSystem/Timeout/react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function LastNameFirstLetter({
  children,
  viewPath = "/App/Account/LastNameFirstLetter",
  from
  
}) {
  let isBefore = useIsBefore()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let checkinLastNameFirstLetterValueData = fromData.useDataValue({ viewPath,
context: 'checkin',
path: 'last_name_first_letter',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  from
  
})
  return (<React.Fragment
>
<div
  data-testid="LastNameFirstLetter.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-Z1QLSyv': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="LastNameFirstLetter.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Question
  viewPath={`${viewPath}/Question`}
 text="Please select the first letter of your last name"
 marginRight="auto"
/>
</div>
<div
  data-testid="LastNameFirstLetter.List"
  data-view-path={viewPath}
 className={`views-block ${styles.List}`}
>
{Array.isArray(from) && from.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="choice_radial"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/ChoiceRadial(${item?.id ?? item?._id ?? index})`}
      >
<ChoiceRadial
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/ChoiceRadial(${item?.id ?? item?._id ?? index})`}
 marginBottom={8}
 marginRight={8}
 onClick={onClick}
 width="13.5%"
 data="checkin.last_name_first_letter"
 selected={checkinLastNameFirstLetterValueData}
/>
</ListItem>
)}
</div>
<Timeout
  viewPath={`${viewPath}/Timeout`}
 onTimeout={() => setFlowTo(fromFlow.normalizePath(viewPath, '../Start'))}
 delay={20000}
/>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }